import { AlignmentType, BorderStyle, convertInchesToTwip, Footer, Header, HeightRule, ImageRun, LevelFormat, Packer, PageNumber, PageOrientation, Paragraph, SectionType, ShadingType, Table, TableCell, TableLayoutType, TabStopType, TableOfContents, TableRow, TextDirection, TextRun, VerticalAlign, WidthType, HeadingLevel } from "docx"
import { saveAs } from "file-saver"
import { url } from "../../../../../constants/url"
import { toast } from "react-toastify"
import { auditReportTable, reportAppName } from "./Part1/Page1-Support"
import { Document } from "docx"
import { documentDistribution, documentHistory, documentPreparation, page2Heading } from "./Part1/Page2-Support"
import { TOCHeadings } from "../../Web/AuditReport/Part1/Page3-Support"
import { heading1, heading2, heading3, heading4, heading5, heading6, heading7, heading8, heading9 } from "./Headings/Headings"
import { introductionBulletOne, introductionBulletThree, introductionBulletTwo, introductionText1 } from "./Part1/Page4-Support"
import { scope } from "./Part1/Page5-Support"
import { team } from "./Part1/Page6-Support"
import { auditActivities, auditActivities1, auditPoint1, auditPoint10, auditPoint11, auditPoint12, auditPoint13, auditPoint14, auditPoint15, auditPoint16, auditPoint17, auditPoint18, auditPoint19, auditPoint2, auditPoint20, auditPoint21, auditPoint22, auditPoint23, auditPoint3, auditPoint4, auditPoint5, auditPoint6, auditPoint7, auditPoint8, auditPoint9, timeline1, timelines } from "./Part1/Page7-Support"
import { auditMethodologyText, informationBullet1, informationBullet2, informationBullet3, informationBullet4, informationBullet5, InformationGathering, InformationGatheringText, setUpAndMethodology } from "./Part2/Page8-Support"
import { applicationBulletFive, applicationBulletFour, applicationBulletOne, applicationBulletSix, applicationBulletThree, applicationBulletTwo, applicationThreatModeling, applicationThreatModelingText, overview, SourceCodeReview, sourceCodeText1, sourceCodeText2 } from "./Part2/Page9-Support"
import { tools } from "./Part2/Page10-Support"
import { recommendationBulletOne, recommendationBulletTwo, sumaryText2, SummaryRecommendation, summaryText, summaryText1, summaryUserRoles } from "./Part2/Page11-Support"
import { RiskRating, riskRatingTable, SeverityDetermination, SeverityDeterminationText } from "./Part2/Page12-Support"
import { graphText, graphText1, severityLevelTable, tableText } from "./Part3/Page13-Support"
import { observation1, observation2, observation3 } from "./Part3/Page15-Support"
import { appendicesTable, auditTools } from "./Part3/Page17-Support"

export async function SourceCodeAuditReportSkeleton(props) {
    const {
        date, customerName, author, clientName, consultantName, applicationName, applicationURL, testStartDate,
        testEndDate, environmentType, emailVer, logout, userRoles, critical, high, medium, low, info, vulCount, brokenAccess,
        cryptoFailures, injection, inseureDesign, security, outdatedComp, identification, softwareFailures,
        securityFailures, ssrf, generatedReportData, pocDetails, loading, setLoading, textAreaValue, testingType,
        weakPoints, strongPoints, image, imageUrl, appDiscription, cricatility
    } = props

    const reportName = `Audit Report of ${applicationName} Source Code`

    // page 1 details
    const page11 = reportAppName(applicationName)
    const page12 = auditReportTable(date, testStartDate, testEndDate)

    // page 2 details
    const page21 = page2Heading
    const page22 = documentPreparation(date, applicationName)
    const page23 = documentHistory(date)
    const page24 = documentDistribution(customerName)  /* here add the name, organization, Designation, email id */

    // page 3 details
    const page31 = TOCHeadings

    // page 4 details
    const page41 = heading1
    const page42 = introductionText1(applicationName)
    const page43 = introductionBulletOne(applicationName)
    const page44 = introductionBulletTwo
    const page45 = introductionBulletThree

    // page 5 details
    const page51 = heading2
    const page52 = scope(applicationName, cricatility)

    // page 6 details
    const page61 = heading3
    const page62 = team

    // page 7 details
    const page71 = heading4
    const page72 = auditActivities
    const page73 = auditActivities1
    const page74 = auditPoint1
    const page75 = auditPoint2
    const page76 = auditPoint3
    const page77 = auditPoint4
    const page78 = auditPoint5
    const page79 = auditPoint6
    const page80 = auditPoint7
    const page711 = auditPoint8
    const page712 = auditPoint9
    const page713 = auditPoint10
    const page714 = auditPoint11
    const page715 = auditPoint12
    const page716 = auditPoint13
    const page717 = auditPoint14
    const page718 = auditPoint15
    const page719 = auditPoint16
    const page720 = auditPoint17
    const page721 = auditPoint18
    const page722 = auditPoint19
    const page723 = auditPoint20
    const page724 = auditPoint21
    const page725 = auditPoint22
    const page726 = auditPoint23
    const page727 = timelines
    const page728 = timeline1(testStartDate, testEndDate)

    // page 8 details
    const page81 = heading5
    const page82 = auditMethodologyText(customerName, applicationName)
    const page83 = setUpAndMethodology
    const page84 = InformationGathering
    const page85 = InformationGatheringText
    const page86 = informationBullet1
    const page87 = informationBullet2
    const page88 = informationBullet3
    const page89 = informationBullet4
    const page90 = informationBullet5

    // page 9 details
    const page91 = applicationThreatModeling
    const page92 = applicationThreatModelingText
    const page93 = overview
    const page94 = applicationBulletOne
    const page95 = applicationBulletTwo
    const page96 = applicationBulletThree
    const page97 = applicationBulletFour
    const page98 = applicationBulletFive
    const page99 = applicationBulletSix
    const page100 = SourceCodeReview
    const page911 = sourceCodeText1
    const page912 = sourceCodeText2

    // page 10 details
    const page101 = heading6
    const page102 = tools

    // page 11 details
    const page111 = heading7
    const page112 = summaryText(customerName, applicationName)
    const page113 = summaryText1
    const page114 = sumaryText2(applicationName, testingType)
    const page115 = summaryUserRoles(testingType === "Black box testing methodology (Unauthenticated Testing)" ? " " : userRoles)
    const page116 = SummaryRecommendation
    const page117 = recommendationBulletOne
    const page118 = recommendationBulletTwo

    // page 12 details
    const page121 = SeverityDetermination
    const page122 = SeverityDeterminationText
    const page123 = RiskRating
    const page124 = riskRatingTable

    // page 13 details
    const page131 = graphText
    const page132 = tableText
    const page133 = severityLevelTable(high, medium, low)
    const page134 = graphText1

    // page 15 details
    const page151 = heading8
    const page152 = observation1
    const page153 = observation2
    const page154 = observation3

    // page 17 details
    const page171 = heading9
    const page172 = auditTools
    const page173 = appendicesTable

    const design = {
        page: {
            margin: { top: 500, right: 700, left: 750, header: 870, footer: 850 },
            size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT },
            type: SectionType.CONTINUOUS,
        },
    }
    const rows = [

        new TableRow({

            height: { value: 3000, rule: HeightRule.EXACT },
            children: [
                new TableCell({
                    width: { size: 600, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 100, right: 10, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "SI. No.",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 1500, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 100, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Affected Asset i.e. IP/URL/Application etc.",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 1500, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Observation/Vulnerability title",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 800, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "CVE/CWE",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 500, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Severity",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT,
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 2500, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Recommendation",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 1200, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [

                                new TextRun({

                                    text: "Reference",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 1000, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "New or Repeat observation",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ],
        }),
    ];
    const severityRank = {
        "Critical": 5,
        "High": 4,
        "Medium": 3,
        "Low": 2,
        "Information": 1
    };
    const sortedVulnerabilities = [...generatedReportData].sort(
        (a, b) => severityRank[b.severity] - severityRank[a.severity]
    ); sortedVulnerabilities.forEach((vulnerability, index) => {
        function getSeverityAndColor(severity) {
            let color = "";
            if (severity === "CRITICAL") {
                color = "c00000";
            } else if (severity === "HIGH") {
                color = "ff0000";
            } else if (severity === "MEDIUM") {
                color = "ffc000";
            } else if (severity === "LOW") {
                color = "ffff00";
            } else {
                color = "00b050";
            }
            return { severity, color };
        }

        const severity = vulnerability.severity;
        const { color } = getSeverityAndColor(severity);
        rows.push(
            new TableRow({

                children: [
                    new TableCell({
                        width: { size: 600, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                indent: { left: 50, right: 50, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: `${index + 1}.`,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 1700, type: WidthType.DXA },
                        children: vulnerability.affectedParameter
                            .split(/\r?\n/)
                            .filter(line => line.trim() !== "")
                            .map(line =>
                                new Paragraph({
                                    alignment: AlignmentType.LEFT,
                                    indent: { left: 50, right: 50, top: 50, bottom: 50 },
                                    children: [
                                        new TextRun({
                                            text: line.trim(),
                                            font: "Arial",
                                            size: 22,
                                            color: "000000",
                                            italics: false,
                                            bold: false,
                                        })
                                    ]
                                })
                            ),
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 1500, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: vulnerability.vulnerabilityName,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 800, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                indent: { left: 50, right: 50, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: `CWE - ${vulnerability.cveId}`,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ],


                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 200, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                indent: { left: 140, right: 140, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: severity,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                        allCaps: true
                                    }),
                                ],
                            }),
                        ],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 2700, type: WidthType.DXA },
                        children: [
                            ...vulnerability.recommendation.split(/•\s*/).filter(Boolean).map(bulletText =>
                                new Paragraph({
                                    alignment: AlignmentType.LEFT,
                                    indent: { left: 550, right: 50, top: 50, bottom: 50 },
                                    bullet: { level: 0 },
                                    children: [
                                        new TextRun({
                                            text: bulletText.trim(),
                                            font: "Arial",
                                            size: 22,
                                            color: "000000",
                                            bold: false,
                                        }),
                                    ],
                                }),
                            )

                        ],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 1300, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: "",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 800, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                indent: { left: 50, right: 50, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: "New",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                ],
            }),
        )
    });

    const MAX_WIDTH = 670;

    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const getImageDimensions = (dataUrl) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                const aspectRatio = img.width / img.height;
                const width = Math.min(img.width, MAX_WIDTH);
                const height = width / aspectRatio;
                resolve({ width, height });
            };
            img.onerror = (error) => reject(error);
            img.src = dataUrl;
        });
    };

    const createImageRun = async (file) => {
        try {
            const imageData = await getBase64(file);
            const dimensions = await getImageDimensions(imageData);
            return new ImageRun({
                data: imageData,
                transformation: { width: dimensions.width, height: dimensions.height },
            });
        } catch (error) {
            console.error('Error reading image data:', error);
            return null;
        }
    };

    const fetchImageAsBase64 = async (url) => {
        const response = await fetch(url, { mode: 'cors' });
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }
    const sortVulnerabilities = [...generatedReportData].sort(
        (a, b) => severityRank[b.severity] - severityRank[a.severity]
    ); const docSections = sortVulnerabilities.map(async (vulnerability, index) => {
        const combinedContent = [];

        for (let i = 0; i < (vulnerability.poc || []).length; i++) {
            const pocText = vulnerability.poc[i]?.poc || "";
            const matchingPocDetails = pocDetails.find(
                (p) => p.data.vulId === vulnerability._id
            );
            combinedContent.push(

                new Paragraph({
                    indent: { left: 300 },
                    spacing: { before: 150 },
                    children: [
                        new TextRun({
                            text: `${pocText}`,
                            size: 24,
                            italics: false,
                            bold: false
                        }),
                    ],
                })
            );

            if (matchingPocDetails) {
                const pocFiles = matchingPocDetails.data.files || [];
                const currentPocFiles = pocFiles.filter(
                    (file) => file.pocFolder === `poc-${i}`
                );
                if (currentPocFiles.length > 0) {
                    for (let j = 0; j < currentPocFiles.length; j++) {
                        const file = currentPocFiles[j];
                        if (file.url) {
                            try {
                                const pocImageData = await fetchImageAsBase64(file.url);
                                const dimensions = await getImageDimensions(pocImageData);

                                const imageRun = new ImageRun({
                                    data: pocImageData.split(",")[1],
                                    transformation: {
                                        width: dimensions.width,
                                        height: dimensions.height,
                                    },
                                });
                                combinedContent.push(
                                    new Paragraph({
                                        indent: { left: 350 },
                                        spacing: { before: 200, after: 300 },
                                        children: [imageRun],
                                    })
                                );
                            } catch (error) {
                                console.error(
                                    `❌ Error fetching image for vulnerability`,
                                );
                            }
                        }
                    }
                } else {
                    console.log(
                        `No files found for vulnerability`
                    );
                }
            }
        }

        function getSeverityAndColor(severity) {
            let color = "";

            if (severity === "Critical") {
                color = "c00000";
            } else if (severity === "High") {
                color = "ff0000";
            } else if (severity === "Medium") {
                color = "ffc000";
            } else if (severity === "Low") {
                color = "ffff00";
            } else {
                color = "00b050";
            }

            return { severity, color };
        }

        const severity = vulnerability.severity;
        const { color } = getSeverityAndColor(severity);

        return [
            new Paragraph({
                pageBreakBefore: true,
                children: [new TextRun({
                    size: 8,
                })]
            }),
            new Paragraph({
                heading: HeadingLevel.HEADING_3,
                tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
                indent: { left: 500 },
                spacing: { before: 30, after: 400 },
                numbering: { reference: "my-crazy-numbering", level: 1 },
                width: { size: 100, type: WidthType.PERCENTAGE },
                children: [
                    new TextRun({
                        text: vulnerability.vulnerabilityName,
                        size: 24,
                        color: "000000",
                        font: "Arial",
                        bold: true,
                        italics: false
                    })
                ],
            }),

            new Table({
                width: { size: 10300, type: WidthType.DXA },
                alignment: AlignmentType.CENTER,
                borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                },
                layout: TableLayoutType.FIXED,
                rows: [
                    new TableRow({
                        children: [
                            new TableCell({

                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Affected Asset",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: vulnerability.affectedParameter
                                    .split(/\r?\n/)
                                    .filter(line => line.trim() !== "")
                                    .map(line =>
                                        new Paragraph({
                                            alignment: AlignmentType.LEFT,
                                            indent: { left: 100, right: 100 },
                                            children: [
                                                new TextRun({
                                                    text: line.trim(),
                                                    font: "Arial",
                                                    size: 24,
                                                    color: "000000",
                                                    italics: false,
                                                    bold: false
                                                })
                                            ]
                                        })
                                    ),
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Observation/ Vulnerability Title",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: vulnerability.vulnerabilityName,
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Detailed Observation",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: vulnerability.description,
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "CVE/CWE",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "NA",
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Control Objective",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "NA",
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Control Name",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "NA",
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Audit Requirement",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "NA",
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false,
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),



                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Risk Rating",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: `${severity}`,
                                            font: "Arial",
                                            size: 24,
                                            color: color,
                                            italics: false,
                                            bold: true,
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Recommendation",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        indent: { left: 100, right: 80 },
                                        spacing: { before: 100, after: 100 },
                                        children: [
                                            new TextRun({
                                                text: "It is Recommended to:",
                                                font: "Arial",
                                                size: 24,
                                                color: "000000",
                                                italics: false,
                                                bold: false
                                            }),
                                        ]
                                    }),
                                    ...vulnerability.recommendation.split(/•\s*/).filter(Boolean).map(bulletText =>
                                        new Paragraph({
                                            spacing: { before: 50, after: 50 },
                                            alignment: AlignmentType.LEFT,
                                            indent: { left: 700, right: 100 },
                                            bullet: { level: 0 },
                                            children: [new TextRun({
                                                text: bulletText.trim(),
                                                font: "Arial",
                                                size: 24,
                                                color: "000000",
                                                italics: false,
                                                bold: false,
                                            })
                                            ]
                                        })
                                    )
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Reference",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [
                                            new TextRun({
                                                text: vulnerability.reference,
                                                font: "Arial",
                                                size: 24,
                                                color: "000000",
                                                italics: false,
                                                bold: false,
                                            })
                                        ]
                                    })
                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "New or Repeat Observation",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "New",
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false,
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),
                ]
            }),

            new Paragraph({
                pageBreakBefore: true,
                children: [new TextRun({
                    size: 14,
                })]
            }),

            new Paragraph({

                spacing: { before: 50, line: 356 },
                children: [
                    new TextRun({
                        text: "Proof of Concept",
                        size: 24,
                        color: "000000",
                        font: "Arial",
                        bold: true,
                        italics: false

                    })
                ],
            }),

            ...combinedContent
        ]
    })
    const docSectionsResolved = await Promise.all(docSections);

    const doc = new Document({
        creator: "manjesh",
        features: { updateFields: true },
        numbering: {
            config: [
                {
                    reference: "my-crazy-numbering",
                    levels: [
                        {
                            level: 0,
                            format: LevelFormat.DECIMAL,
                            text: "%1.",
                            alignment: AlignmentType.RIGHT,
                            style: {
                                paragraph: {
                                    indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                                },
                                run: {
                                    size: 40,
                                    bold: true,
                                    color: "2F5496",
                                },
                            },
                        },
                        {
                            level: 1,
                            format: LevelFormat.DECIMAL,
                            text: "8.%2",
                            alignment: AlignmentType.RIGHT,
                            style: {
                                paragraph: {
                                    indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                                },
                                text: { color: "000000", bold: true, size: 24, font: "Arial" },
                                run: {
                                    size: 24,
                                    bold: true,
                                    color: "000000",
                                    font: "Arial"
                                },
                            },
                        },

                    ]
                }
            ]
        },
        styles: {
            default: {

                document: {
                    run: {
                        font: "Arial",
                        bold: true,
                        size: 24,
                        color: "000000",
                    },
                },
                heading1: {
                    run: {

                        font: "Arial",
                        bold: true,
                        italics: false,
                        allCaps: false
                    },
                    paragraph: { spacing: { line: 276 } },
                },
            },
        },
        sections: [
            //---------------------- page 1 Start----------------------
            {
                properties: { ...design },
                headers: {
                    default: new Header({
                        children: [
                            new Table({
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                alignment: AlignmentType.RIGHT,
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    bottom: { style: BorderStyle.THICK_THIN_MEDIUM_GAP, size: 3 * 8, color: "D00014" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" }
                                },
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: { size: 100, type: WidthType.PERCENTAGE },
                                                children: [
                                                    new Paragraph({
                                                        alignment: AlignmentType.RIGHT,
                                                        children: [
                                                            new TextRun({
                                                                text: "<Confidential>",
                                                                size: 24,
                                                                font: "Arial",
                                                                color: '000000',
                                                                bold: false
                                                            })
                                                        ]
                                                    })],
                                                borders: {
                                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    bottom: { style: BorderStyle.THICK_THIN_MEDIUM_GAP, size: 3 * 8, color: "D00014" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                },
                footers: {
                    default: new Footer({
                        children: [
                            new Table({
                                margin: { top: 600 },
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                borders: {
                                    top: { style: BorderStyle.THICK_THIN_MEDIUM_GAP, size: 3 * 8, color: "D00014" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                },
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: { size: 5, type: WidthType.PERCENTAGE },
                                                spacing: { before: 100 },
                                                children: [
                                                    new Paragraph({
                                                        alignment: AlignmentType.LEFT,
                                                        children: [
                                                            new TextRun({
                                                                text: "Page",
                                                                italics: false,
                                                                font: "Calibri",
                                                                size: 24,
                                                                color: "002060",
                                                                bold: false
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                                borders: {
                                                    top: { style: BorderStyle.THICK_THIN_MEDIUM_GAP, size: 3 * 8, color: "D00014" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                            new TableCell({
                                                width: { size: 18, type: WidthType.PERCENTAGE },
                                                spacing: { before: 100 },
                                                children: [
                                                    new Paragraph({
                                                        alignment: AlignmentType.LEFT,
                                                        children: [
                                                            new TextRun({
                                                                children: [PageNumber.CURRENT],
                                                                italics: false,
                                                                font: "Calibri",
                                                                size: 24,
                                                                color: "002060",
                                                                bold: false
                                                            }),

                                                            new TextRun({
                                                                text: " of ",
                                                                italics: false,
                                                                font: "Calibri",
                                                                size: 24,
                                                                color: "002060",
                                                                bold: false
                                                            }),

                                                            new TextRun({
                                                                children: [PageNumber.TOTAL_PAGES],
                                                                italics: false,
                                                                font: "Calibri",
                                                                size: 24,
                                                                color: "002060",
                                                                bold: false
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                                borders: {
                                                    top: { style: BorderStyle.THICK_THIN_MEDIUM_GAP, size: 3 * 8, color: "D00014" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),

                                            new TableCell({
                                                width: { size: 77, type: WidthType.PERCENTAGE },
                                                spacing: { before: 100 },
                                                children: [
                                                    new Paragraph({
                                                        indent: { right: 200 },
                                                        alignment: AlignmentType.RIGHT,
                                                        children: [
                                                            new TextRun({
                                                                text: "Cert-In Audit report format: Version 1.0",
                                                                font: "Calibri",
                                                                size: 24,
                                                                italics: false,
                                                                color: "002060",
                                                                bold: false
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                                borders: {
                                                    top: { style: BorderStyle.THICK_THIN_MEDIUM_GAP, size: 3 * 8, color: "D00014" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                        ]
                                    })
                                ]

                            })
                        ]
                    })
                },
                children: [page11, page12],
                pageBreakBefore: true,
            },
            //---------------------- page 1 End----------------------
            //---------------------- page 2 Start----------------------
            {
                properties: { ...design },
                children: [page21, page22, new Paragraph({ spacing: { after: 600 }, }), page23, new Paragraph({ spacing: { after: 600 } }), page24],
                pageBreakBefore: true,
            },
            //---------------------- page 2 End----------------------
            //---------------------- page 3 Start----------------------
            {
                properties: { ...design },
                children: [page31, new Table({
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    layout: TableLayoutType.FIXED,
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                    alignment: AlignmentType.LEFT,
                    rows: [
                        new TableRow({

                            children: [
                                new TableCell({
                                    width: { size: 100, type: WidthType.PERCENTAGE },
                                    children: [
                                        new Paragraph({
                                            children: [
                                                new TableOfContents("Table of Content", {
                                                    hyperlink: true,
                                                    headingStyleRange: "1-5",
                                                }),
                                            ],
                                        }),
                                    ],
                                }),
                            ],
                        }),
                    ],
                }),],
                pageBreakBefore: true
            },
            //---------------------- page 3 End----------------------
            //---------------------- page 4 Start----------------------
            {
                properties: { ...design },
                children: [page41, page42, page43, page44, page45],
                pageBreakBefore: true
            },
            //---------------------- page 4 End----------------------
            //---------------------- page 5 Start----------------------
            {
                properties: { ...design },
                children: [page51, page52],
                pageBreakBefore: true
            },
            //---------------------- page 5 End----------------------
            //---------------------- page 6 Start----------------------
            {
                properties: { ...design },
                children: [page61, page62],
                pageBreakBefore: true
            },
            //---------------------- page 6 End----------------------
            //---------------------- page 7 Start----------------------
            {
                properties: { ...design },
                children: [page71, page72, page73, page74, page75, page76, page77, page78, page79, page80, page711, page712, page713, page714, page715, page716, page717, page718, page719, page720, page721, page722, page723, page724, page725, page726, page727, page728],
                pageBreakBefore: true
            },
            //---------------------- page 7 End----------------------
            //---------------------- page 8 Start----------------------
            {
                properties: { ...design },
                children: [page81, page82, page83, page84, page85, page86, page87, page88, page89, page90],
                pageBreakBefore: true
            },
            //---------------------- page 8 End----------------------
            //---------------------- page 9 Start----------------------
            {
                properties: { ...design },
                children: [page91, page92, page93, page94, page95, page96, page97, page98, page99, page100, page911, page912],
                pageBreakBefore: true
            },
            //---------------------- page 9 End----------------------
            //---------------------- page 10 Start----------------------
            {
                properties: { ...design },
                children: [page101, page102],
                pageBreakBefore: true
            },
            //---------------------- page 10 End----------------------
            //---------------------- page 11 Start----------------------
            {
                properties: { ...design },
                children: [page111, page112, page113, page114, page115, page116, page117, page118],
                pageBreakBefore: true
            },
            //---------------------- page 11 End----------------------
            //---------------------- page 12 Start----------------------
            {
                properties: { ...design },
                children: [page121, page122, page123, page124],
                pageBreakBefore: true
            },
            //---------------------- page 12 End----------------------
            //---------------------- page 13 Start----------------------
            {
                properties: { ...design },
                children: [page131, page132, page133, page134],
                pageBreakBefore: true
            },
            //---------------------- page 13 End----------------------
            //---------------------- page 14 Start----------------------
            {
                properties: { ...design },
                children: [new Paragraph({}),
                new Table({
                    width: { size: 10335, type: WidthType.DXA },
                    layout: TableLayoutType.FIXED,
                    alignment: AlignmentType.CENTER,

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    },
                    rows: rows
                })],
                pageBreakBefore: true
            },
            //---------------------- page 14 End----------------------
            //---------------------- page 15 Start----------------------
            {
                properties: { ...design },
                children: [page151, page152, page153, page154],
                pageBreakBefore: true
            },
            //---------------------- page 15 End----------------------
            {
                properties: { ...design },
                children: [...docSectionsResolved.flat()],
                pageBreakBefore: true
            },
            {
                properties: { ...design },
                children: [page171, page172, page173],
                pageBreakBefore: true
            }
        ]

    })


    try {
        setLoading(true)
        const response = await fetch(`${url}/reportdownload`, {
            method: 'POST',
            credentials: 'include'
        })
        if (response.status === 200) {
            Packer.toBlob(doc).then(blob => {
                saveAs(blob, `${reportName}.docx`);
            });
            setLoading(false)
            return
        }
        if (response.status !== 200) {
            setLoading(false)
            return
        }
        if (response.status === 440) {
            setLoading(false)
            logout()
            toast.error("User logout due to inactivity", {
                position: 'top-right',
                autoClose: 2500,
                pauseOnHover: false,
            });
            return
        }

    } catch (error) {
        console.log(error)
    }
}